<template>
  <b-dropdown-item
    v-if="list"
    @click="click"
  >
    <div class="d-flex align-items-center">
      <b-img
        v-if="imageSrc"
        :id="btnId"
        :src="imageSrc"
        rounded="circle"
        class="list-icon"
      />
      <font-awesome-icon
        v-else
        :id="btnId"
        class="fa-icon-as-button list-icon"
        :icon="icon"
        style="padding: 0.3em;"
      />
      <label
        :for="btnId"
        class="m-0 pl-2"
      >
        {{ label }}
      </label>
    </div>
  </b-dropdown-item>
  <div
    v-else
    class="d-flex flex-column text-center mx-1 cursor-pointer"
    @click="click"
  >
    <b-img
      v-if="imageSrc"
      :id="btnId"
      :src="imageSrc"
      rounded="circle"
      class="nav-icon-button"
    />
    <font-awesome-icon
      v-else
      :id="btnId"
      class="fa-icon-as-button nav-icon-button"
      :icon="icon"
      style="padding: 0.6em;"
    />

    <label
      :for="btnId"
      class="cursor-pointer button-width"
    >
      {{ label }}
    </label>
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  list: Boolean,
  imageSrc: {
    type: String,
    default: '',
  },
  link: {
    type: Object,
    default: null,
  },
  label: {
    type: String,
    default: '',
  },
  btnId: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
}

@Component
export default class NavButton extends Vue.extend({ props }) {
  click () {
    if (this.link) this.$router.push(this.link)
    this.$emit('click')
  }
}

</script>

<style scoped>
.list-icon {
  height: 1.5em;
  width: 1.5em;
}

.nav-icon-button {
  height: 3.5em;
  width: 3.5em;
}

.button-width {
  width: 3.5em;
}

.cursor-pointer {
  cursor: pointer;
}

.fa-icon-as-button {
  background: black;
  color: white;
  border-radius: 50%;
}

</style>
